// src/components/Settings/SettingsComponents/ConnectorManagement.tsx

import React from "react";
import ViewConnector from "./ConnectorManagementComponents/ViewConnector";

const ConnectorManagement: React.FC = () => {
  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
      <ViewConnector />
    </div>
  );
};

export default ConnectorManagement;